import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Breakdown } from '../../../templates/Breakdown';

export const PeriodicEven: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicEven.${label}.${locale}.json`)}>
      <PeriodicEvenComponent />
    </I18nProvider>
  );
};

export const PeriodicEvenComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicEven'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Breakdown
      title={t('periodicEven.title')}
      content={t('periodicEven.content')}
      buttonHref={t('periodicEven.buttonLink.href')}
      buttonText={t('periodicEven.buttonLink.text')}
      footerLabel={t('periodicEven.priceDetailsFooterLabel')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicEven.imageSrc')}`,
        },
      }}
    />
  );
};
